module.exports = __webpack_public_path__ + "static/media/test8_4.5a6f29f9.png";